const LISTE_PRODUITS_ACHAT_LOC = {
  title: 'Liste des produits d\'achat location',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste produits d\'achat location',
  },
  actions: {
    search: 'Rechercher',
    add: 'Nouveau produit',
    edit: 'Modifier',
    delete: 'Supprimer',
    desarchiver: 'Désarchiver',
    archiver: 'Archiver',
    filtre: 'Filtre',
  },
  tabs: {
    libelle: 'Libellé',
    reference: 'Référence',
    societe: 'Société',
    schemaComptable: 'Schéma comptable',
    actif: 'Archivé',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    actif: 'Actif',
    yes: 'Oui',
    no: 'Non',
    societe: 'Societé',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  archivage: {
    archiver: 'Etes-vous sûr de vouloir archiver ce produit ?',
    desarchiver: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    sucessArchivage: 'Produit archivé avec succès',
    successDesarchivage: 'Produit désarchivé avec succès',
  },
};

export default LISTE_PRODUITS_ACHAT_LOC;
